import { Button, Card, Col, Form, Row } from '@themesberg/react-bootstrap';
import React, { useEffect, useState } from 'react';
import ToggleSwitch from '../common/ToggleSwitch';
import { useTranslation } from 'react-i18next';
import { ErrorMessage } from '../StyledComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdd, faSync, faXmark } from '@fortawesome/free-solid-svg-icons';
import EditableDropDown from '../../../../components/common/EditableDropdown';
import { arrayToDropdownOptions } from '../../../../utils/sms/arrayToDropdownOptions';
import {
  indexingSchemeTypes,
  schemeTypeMap,
} from '../../../../utils/sms/constantsAndUtils';

const AddProductDetails = (props) => {
  const {
    formInput,
    setFormInput,
    formProps,
    setFormProps,
    formErrors,
    productOptions,
    categoryOptions,
    fetchProducts,
    subCategoryOptions,
    setCategoryOptions,
  } = props;
  const { t } = useTranslation();
  const [colSize, setColSize] = useState(3);

  const handleChange = (checked, field) => {
    setFormProps((prev) => ({
      ...prev,
      [field]: checked,
    }));
  };

  const handleInputChange = (e, field, targetIndex, type) => {
    let value = '';
    if (type === 'dropdown') {
      value = [e.value];
    } else {
      value = e.target.value;
    }

    setFormInput((prev) => ({
      ...prev,
      products: prev.products?.map((item, index) => {
        if (index === targetIndex) {
          return {
            ...item,
            [field]: value,
          };
        }
        return item;
      }),
    }));
  };

  const handleDelete = (targetIndex) => {
    if (formInput.products.length === 1) {
      return;
    }
    setFormInput((prev) => ({
      ...prev,
      products: prev.products.filter((item, index) => index !== targetIndex),
    }));
  };

  const getUniqueProductSubCategories = (
    value,
    subCategory,
    targetSubCategory,
    key
  ) => {
    const filteredOptions = subCategoryOptions.reduce((acc, item) => {
      if (
        value.includes(item[subCategory]) &&
        !acc.includes(item[targetSubCategory])
      ) {
        item[targetSubCategory] && acc.push(item[targetSubCategory]);
      }
      return acc;
    }, []);
    setCategoryOptions((prev) => ({
      ...prev,
      [key]: arrayToDropdownOptions(filteredOptions),
    }));
    return filteredOptions;
  };

  const handleAddProduct = () => {
    setFormInput((prev) => {
      const lastProduct = prev?.products?.[prev?.products.length - 1];
      return {
        ...prev,
        products: [
          ...prev.products,
          {
            productName: [],
            cappingType:
              formProps.copyCappingType && lastProduct
                ? lastProduct.cappingType
                : '',
            valuationType:
              formProps.copyValuationType && lastProduct
                ? lastProduct.valuationType
                : '',
            payout:
              formProps.copyPayoutValue && lastProduct
                ? lastProduct.payout
                : '',
          },
        ],
      };
    });
  };

  useEffect(() => {
    let newColSize = 3;
    if (['Upgrade-offer', 'Liquidation'].includes(formInput.type?.[0])) {
      newColSize = Math.floor(12 / 5);
    }
    if (formProps.showCappingType || formProps.addTarget) {
      newColSize = 2;
    }
    setColSize(newColSize);
  }, [formProps.showCappingType, formInput.type, formProps.addTarget]);

  return (
    <div>
      <Card className="p-2">
        <div className="d-flex flex-row">
          <div className="w-50  p-2">
            <Form.Group className="mb-2">
              <Form.Label>{t('Category*')}</Form.Label>
              <EditableDropDown
                id={'category'}
                onChange={(e) =>
                  setFormInput((prev) => ({
                    ...prev,
                    category: e.map(({ value }) => value),
                  }))
                }
                value={formInput['category']}
                options={categoryOptions.categoryOptions}
                placeholder={'Choose Category/Categories'}
                isInvalid={formErrors['category']}
                isMultiSelect={true}
                backgroundColor="#F0F0F0"
                optionColor="#FFFFFF"
              ></EditableDropDown>
              <ErrorMessage>{formErrors['category']}</ErrorMessage>
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>{t('Sub Category-1')}</Form.Label>
              <EditableDropDown
                id={'subCategory'}
                onChange={(e) => {
                  const value = e.map(({ value }) => value);
                  const filteredOptions = getUniqueProductSubCategories(
                    value,
                    'productSubCategory1',
                    'productSubCategory2',
                    'subCategory2Options'
                  );
                  setFormInput((prev) => ({
                    ...prev,
                    subCategory: value,
                    subCategory2: prev.subCategory2?.filter((item) =>
                      filteredOptions.includes(item)
                    ),
                  }));
                }}
                value={formInput['subCategory']}
                options={categoryOptions.subCategory1Options}
                placeholder={'Choose Sub Category-1'}
                isInvalid={formErrors['subCategory']}
                isMultiSelect={true}
                backgroundColor="#F0F0F0"
                optionColor="#FFFFFF"
              ></EditableDropDown>
              <ErrorMessage>{formErrors['subCategory']}</ErrorMessage>
            </Form.Group>
          </div>
          <div className="w-50  p-2">
            <Form.Group className="mb-2">
              <Form.Label>{t('Sub Category-2')}</Form.Label>
              <EditableDropDown
                id={'subCategory2'}
                onChange={(e) => {
                  const value = e.map(({ value }) => value);
                  const filteredOptions = getUniqueProductSubCategories(
                    value,
                    'productSubCategory2',
                    'productSubCategory3',
                    'subCategory3Options'
                  );
                  setFormInput((prev) => ({
                    ...prev,
                    subCategory2: value,
                    subCategory3: prev.subCategory3?.filter((item) =>
                      filteredOptions.includes(item)
                    ),
                  }));
                }}
                value={formInput['subCategory2']}
                options={categoryOptions.subCategory2Options}
                placeholder={'Choose Sub Category-2'}
                isInvalid={formErrors['subCategory2']}
                isMultiSelect={true}
                backgroundColor="#F0F0F0"
                optionColor="#FFFFFF"
              ></EditableDropDown>
              <ErrorMessage>{formErrors['subCategory2']}</ErrorMessage>
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>{t('Sub Category-3')}</Form.Label>
              <EditableDropDown
                id={'subCategory3'}
                onChange={(e) =>
                  setFormInput((prev) => ({
                    ...prev,
                    subCategory3: e.map(({ value }) => value),
                  }))
                }
                value={formInput['subCategory3']}
                options={categoryOptions.subCategory3Options}
                placeholder={'Choose Sub Category-3'}
                isInvalid={formErrors['subCategory3']}
                isMultiSelect={true}
                backgroundColor="#F0F0F0"
                optionColor="#FFFFFF"
              ></EditableDropDown>
              <ErrorMessage>{formErrors['subCategory3']}</ErrorMessage>
            </Form.Group>
          </div>
        </div>
        {!formInput.uploadExcel && (
          <div className="d-flex justify-content-start">
            <Button
              style={{
                backgroundColor: '#F0F0F0',
                border: '2px solid red',
                color: 'black',
              }}
              onClick={fetchProducts}
            >
              <FontAwesomeIcon icon={faSync} /> &nbsp;&nbsp; Fetch Products
            </Button>
          </div>
        )}
      </Card>

      {formInput?.sellInType?.[0] !== 'Indexing' ||
        (!indexingSchemeTypes.includes(formInput.type?.[0]) && (
          <>
            {[schemeTypeMap.sellIn, schemeTypeMap.sellOut].includes(
              formInput.type?.[0]
            ) && (
              <div className="d-flex justify-content-end">
                <ToggleSwitch
                  type={'secondary'}
                  input={formProps.addTarget}
                  setInput={(checked) => handleChange(checked, 'addTarget')}
                  name={'Add Target'}
                />
                {formInput.type?.[0] === 'Sell-out' && (
                  <ToggleSwitch
                    type={'secondary'}
                    input={formProps.showCappingType}
                    setInput={(checked) =>
                      handleChange(checked, 'showCappingType')
                    }
                    name={'Add Capping Type'}
                  />
                )}
              </div>
            )}
            <Card className="p-2 mt-2">
              <div className="d-flex justify-content-end align-items-center">
                <div className="d-flex gap-3">
                  {formProps.showCappingType && (
                    <div className="d-flex align-items-center gap-3 p-2">
                      <Form.Label className="mb-0">
                        Copy Capping Type
                      </Form.Label>
                      <Form.Group>
                        <Form.Check
                          type="checkbox"
                          id={'copyCappingType'}
                          checked={formProps.copyCappingType}
                          onChange={(e) =>
                            handleChange(e.target.checked, 'copyCappingType')
                          }
                          className="custom-checkbox"
                        />
                      </Form.Group>
                    </div>
                  )}
                  <div className="d-flex align-items-center gap-3 p-2">
                    <Form.Label className="mb-0">
                      Copy Valuation Type
                    </Form.Label>
                    <Form.Group>
                      <Form.Check
                        type="checkbox"
                        id={'copyValuationType'}
                        checked={formProps.copyValuationType}
                        onChange={(e) =>
                          handleChange(e.target.checked, 'copyValuationType')
                        }
                        className="custom-checkbox"
                      />
                    </Form.Group>
                  </div>
                  <div className="d-flex align-items-center gap-3 p-2">
                    <Form.Label className="mb-0">Copy Payout Value</Form.Label>
                    <Form.Group>
                      <Form.Check
                        type="checkbox"
                        id={'copyPayoutValue'}
                        checked={formProps.copyPayoutValue}
                        onChange={(e) =>
                          handleChange(e.target.checked, 'copyPayoutValue')
                        }
                        className="custom-checkbox"
                      />
                    </Form.Group>
                  </div>
                </div>
              </div>
            </Card>
            {formInput.type?.[0] !== schemeTypeMap.foc && (
              <Card className="p-2 mt-2">
                <Row className="p-2" style={{ width: '95%' }}>
                  <Col md={colSize}>Product*</Col>
                  <Col md={colSize}>Valuation Type*</Col>
                  <Col md={colSize}>Payout (% or Per Unit)*</Col>
                  {formInput?.products?.some(
                    (item) =>
                      item?.valuationType?.[0]?.toLowerCase() === 'percentage'
                  ) && <Col md={colSize}>Payout Basis*</Col>}
                  {formProps.showCappingType &&
                    formInput?.type?.[0] === 'Sell-out' && (
                      <>
                        <Col md={colSize}>Capping Type</Col>
                        <Col md={colSize}>Amount/Quantity</Col>
                      </>
                    )}
                  {['Upgrade-offer', 'Liquidation'].includes(
                    formInput.type[0]
                  ) && (
                    <>
                      <Col md={colSize}>Brand Amount*</Col>
                      <Col md={colSize}>VS Amount*</Col>
                    </>
                  )}
                  {formProps.addTarget &&
                    [schemeTypeMap.sellIn, schemeTypeMap.sellOut].includes(
                      formInput.type?.[0]
                    ) && <Col md={colSize}>Target*</Col>}
                </Row>
                {formInput?.products?.map((item, index) => (
                  <div className="d-flex justify-content-between align-items-center">
                    <Row
                      key={index}
                      className="d-flex align-items-center mt-2 p-2"
                      style={{ width: '95%' }}
                    >
                      <Col md={colSize}>
                        <Form.Group>
                          <EditableDropDown
                            id={'productName'}
                            onChange={(e) =>
                              handleInputChange(
                                e,
                                'productName',
                                index,
                                'dropdown'
                              )
                            }
                            value={item.productName}
                            options={productOptions}
                            isInvalid={
                              formErrors?.products?.[index]?.productName
                            }
                            backgroundColor={'#F0F0F0'}
                          ></EditableDropDown>
                          <ErrorMessage>
                            {formErrors?.products?.[index]?.productName}
                          </ErrorMessage>
                        </Form.Group>
                      </Col>
                      <Col md={colSize}>
                        <Form.Group>
                          <EditableDropDown
                            id={'valuationType'}
                            onChange={(e) =>
                              handleInputChange(
                                e,
                                'valuationType',
                                index,
                                'dropdown'
                              )
                            }
                            value={item.valuationType}
                            options={[
                              { label: 'percentage', value: 'percentage' },
                              { label: 'value', value: 'value' },
                            ]}
                            isInvalid={
                              formErrors?.products?.[index]?.valuationType
                            }
                            backgroundColor={'#F0F0F0'}
                          ></EditableDropDown>
                          <ErrorMessage>
                            {formErrors?.products?.[index]?.valuationType}
                          </ErrorMessage>
                        </Form.Group>
                      </Col>
                      <Col md={colSize}>
                        <Form.Group>
                          <Form.Control
                            type="number"
                            value={item.payout}
                            onChange={(e) =>
                              handleInputChange(e, 'payout', index)
                            }
                            style={{ backgroundColor: '#F0F0F0' }}
                            placeholder="Enter Payout"
                            isInvalid={formErrors?.products?.[index]?.payout}
                          />
                          <ErrorMessage>
                            {formErrors?.products?.[index]?.payout}
                          </ErrorMessage>
                        </Form.Group>
                      </Col>
                      {formInput?.products?.some(
                        (item) =>
                          item?.valuationType?.[0]?.toLowerCase() ===
                          'percentage'
                      ) && (
                        <Col md={colSize}>
                          <Form.Group>
                            <EditableDropDown
                              id={'payoutBasis'}
                              onChange={(e) =>
                                setFormInput((prev) => ({
                                  ...prev,
                                  payoutBasis: [e.value],
                                }))
                              }
                              value={item['payoutBasis']}
                              isInvalid={
                                formErrors?.products?.[index]?.payoutBasis
                              }
                              options={[
                                { label: 'DP', value: 'DP' },
                                { label: 'DP(Basic)', value: 'DP(Basic)' },
                                {
                                  label: 'Net of Margin',
                                  value: 'Net of Margin',
                                },
                                { label: 'NLC(Basic)', value: 'NLC(Basic)' },
                              ]}
                              placeholder={'Choose Payout Basis'}
                              backgroundColor="#F0F0F0"
                            ></EditableDropDown>
                            <ErrorMessage>
                              {formErrors?.products?.[index]?.payoutBasis}
                            </ErrorMessage>
                          </Form.Group>
                        </Col>
                      )}
                      {formProps.showCappingType &&
                        formInput.type?.[0] === 'Sell-out' && (
                          <>
                            <Col md={colSize}>
                              <Form.Group>
                                <EditableDropDown
                                  id={'cappingType'}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e,
                                      'cappingType',
                                      index,
                                      'dropdown'
                                    )
                                  }
                                  value={item.cappingType}
                                  options={[
                                    { label: 'Quantity', value: 'Quantity' },
                                    { label: 'Revenue', value: 'Revenue' },
                                  ]}
                                  isInvalid={
                                    formErrors?.products?.[index]?.cappingType
                                  }
                                  backgroundColor={'#F0F0F0'}
                                  optionColor="#FFFFFF"
                                ></EditableDropDown>
                                <ErrorMessage>
                                  {formErrors?.products?.[index]?.cappingType}
                                </ErrorMessage>
                              </Form.Group>
                            </Col>
                            <Col md={colSize}>
                              <Form.Group>
                                <Form.Control
                                  type="number"
                                  value={item.cappingQuantity}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e,
                                      'cappingQuantity',
                                      index
                                    )
                                  }
                                  style={{ backgroundColor: '#F0F0F0' }}
                                  placeholder="Enter Payout"
                                  isInvalid={
                                    formErrors?.products?.[index]
                                      ?.cappingQuantity
                                  }
                                />
                                <ErrorMessage>
                                  {
                                    formErrors?.products?.[index]
                                      ?.cappingQuantity
                                  }
                                </ErrorMessage>
                              </Form.Group>
                            </Col>
                          </>
                        )}
                      {formProps.addTarget &&
                        [schemeTypeMap.sellIn, schemeTypeMap.sellOut].includes(
                          formInput.type?.[0]
                        ) && (
                          <>
                            <Col md={colSize}>
                              <Form.Group>
                                <Form.Control
                                  type="number"
                                  value={item.target}
                                  onChange={(e) =>
                                    handleInputChange(e, 'target', index)
                                  }
                                  style={{ backgroundColor: '#F0F0F0' }}
                                  placeholder="Enter target"
                                  isInvalid={
                                    formErrors?.products?.[index]?.target
                                  }
                                />
                                <ErrorMessage>
                                  {formErrors?.products?.[index]?.target}
                                </ErrorMessage>
                              </Form.Group>
                            </Col>
                          </>
                        )}
                      {['Upgrade-offer', 'Liquidation'].includes(
                        formInput.type[0]
                      ) && (
                        <>
                          <Col md={colSize}>
                            <Form.Group>
                              <Form.Control
                                type="number"
                                value={item.brandAmount}
                                onChange={(e) =>
                                  handleInputChange(e, 'brandAmount', index)
                                }
                                style={{ backgroundColor: '#F0F0F0' }}
                                placeholder="Enter Brand Amount"
                                isInvalid={
                                  formErrors?.products?.[index]?.brandAmount
                                }
                              />
                              <ErrorMessage>
                                {formErrors?.products?.[index]?.brandAmount}
                              </ErrorMessage>
                            </Form.Group>
                          </Col>
                          <Col md={colSize}>
                            <Form.Group>
                              <Form.Control
                                type="number"
                                value={item.vsAmount}
                                onChange={(e) =>
                                  handleInputChange(e, 'vsAmount', index)
                                }
                                style={{ backgroundColor: '#F0F0F0' }}
                                placeholder="Enter VS Amount"
                                isInvalid={
                                  formErrors?.products?.[index]?.vsAmount
                                }
                              />
                              <ErrorMessage>
                                {formErrors?.products?.[index]?.vsAmount}
                              </ErrorMessage>
                            </Form.Group>
                          </Col>
                        </>
                      )}
                    </Row>
                    <div style={{ height: '47.5px', width: '30px' }}>
                      <Button
                        style={{
                          backgroundColor: '#F0F0F0',
                          border: 'none',
                          height: '43.50px',
                        }}
                        onClick={() => handleDelete(index)}
                      >
                        <FontAwesomeIcon
                          icon={faXmark}
                          style={{ color: 'black' }}
                        />
                      </Button>
                    </div>
                  </div>
                ))}
                <div className="d-flex justify-content-end mb-4">
                  <Button
                    style={{
                      backgroundColor: '#F0F0F0',
                      border: 'none',
                      color: 'black',
                    }}
                    onClick={handleAddProduct}
                  >
                    <FontAwesomeIcon icon={faAdd} /> &nbsp;&nbsp; Add Product
                  </Button>
                </div>
              </Card>
            )}
          </>
        ))}
    </div>
  );
};

export default AddProductDetails;
